import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import AppHeader from './AppHeader';
import './App.scss';
import { useEffect, useState } from 'react';
import LoadingPage from './LoadingPage';
import EngagementDetailsPage from './engagements/EngagementDetailsPage';
import EngagementsPage from './engagements/EngagementsPage';
import JobDetailsPage from './jobs/JobDetailsPage';
import api from '../helpers/api';
import NotFoundPage from './NotFoundPage';
import {PagedResult} from "../models/dto/pagedResult";
import JobAudioErrorPage from './jobs/JobAudioErrorPage';
import { EngagementSummary } from '../models/dto/engagement';
import {
	JobListQuery,
	JobSummary
} from '../models/dto/job';
import CreateJobPageRouter from './jobs/CreateJobPageRouter';

export default function App() {
	const [routingData, setRoutingData] = useState<RoutingData | null>(null);

	useEffect(() => {
		api.get<PagedResult<EngagementSummary>>('/api/engagements').then((engagementsResponse) => {
			const engagements = engagementsResponse.data.items ?? [];
			// count the number of engagements that are not complete
			const openEngagementCount = engagements.filter(e => !e.complete).length;
			
			if (engagements.length === 1 || openEngagementCount === 1) {
				const openEngagement = [...engagements].sort((a, b) => {
						return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
					}).find(j => !j.complete),
					engagement = openEngagement ?? engagements[0],
					query: JobListQuery = { engagementId: engagement.id, pageSize: 10000, pageIndex: 1 };
				
				api.get<PagedResult<JobSummary>>('/api/jobs', { params: query }).then(jobsResponse => {
					setRoutingData({
						engagements,
						autoLoadData: { engagement, jobs: jobsResponse.data.items ?? [] }
					});
				});
			} else {
				setRoutingData({ engagements, autoLoadData: null });
			}
		});
	}, []);
	
	if (!routingData) {
		return <LoadingPage />;
	}
	
	return (
		<React.Fragment>
			<AppHeader />
			
			<div className="app__container">
				<Switch>
					<Redirect exact={true} from="/" to={getRedirectUrl(routingData)} />
					<Route path='/engagements/:engagementId/jobs/create' component={CreateJobPageRouter} />
					<Route path='/engagements/:engagementId/jobs-audio-error' component={JobAudioErrorPage} />
					<Route path='/engagements/:engagementId/jobs/:jobId' component={JobDetailsPage} />
					<Route path='/engagements/:engagementId' component={EngagementDetailsPage} />
					<Route path='/engagements' >
						<EngagementsPage engagements={routingData.engagements} />
					</Route>
					<Route path="*">
						<NotFoundPage />
					</Route>
				</Switch>
			</div>
		</React.Fragment>
	);
	
	function getRedirectUrl(data: RoutingData): string {
		if (!data.autoLoadData)
			return '/engagements';
		
		if (data.autoLoadData.engagement.complete)
			return `/engagements/${data.autoLoadData.engagement.id}`;
		
		const openJob = [...data.autoLoadData.jobs].sort((a, b) => {
			return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
		}).find(j => !j.complete);
		
		if (openJob) {
			return `/engagements/${data.autoLoadData.engagement.id}/jobs/${openJob.id}`;
		} else {
			return `/engagements/${data.autoLoadData.engagement.id}/jobs/create`;
		}
	}
}

interface RoutingData {
    engagements: EngagementSummary[];
    autoLoadData: { engagement: EngagementSummary; jobs: JobSummary[]; } | nundefined;
}
